export default {
    lang: "en",
    //登录
    loginIn: 'Log in to',
    logout: 'exit',
    leaderManage: 'Group Platform',
    phoneormail: 'Mobile phone or Email',
    mail: 'Please enter email address',
    phone: 'Please enter your mobile phone number',
    vcode: 'Verification Code',
    rememberaccount: 'Remember the password',
    loginSub: 'log on',
    sendphonemail: 'Mobile phone or email must be entered',
    errorphonemail: 'Incorrect format',
    phoneRequired: 'Mobile phone number is required',
    mailRequired: 'Email address number is required',
    emailLogin: 'Email login',
    phoneLogin: 'Phone login',
    send: 'Send',
    area: 'Country',
    selectArea: 'Please select the country',
    visitor: 'Visitor',
    agentMember: 'Agent Member',
    trader: 'Trader',
    changeCancel: 'To cancel',
    goToComplete: 'Go to complete',
    reload: 'Please reload',
    yz: 'Asia',
    oz: 'Europe',
    fz: 'Africa',
    bm: 'North America',
    nm: 'South America',
    dy: 'Oceania',
    nj: 'Antarctica',
    description: 'Transfer account number',
    selectPhoneorEmail: 'You only need to enter one of the mobile phone numbers or email addresses',
    voucher: 'Transaction receipt',
    voucherPreview: 'Transaction receipt Preview',
    transact: 'Transaction',
    transactTime: 'Transaction time',
    reason: 'Reason',
    ruleName: 'Please enter 2-16 digit numbers or letter combinations',

    msg1: 'Account name must be entered',
    msg2: 'Password required',
    msg3: 'Verification code must be entered',
    msg4: 'Please input the correct mobile phone or email first',
    msg5: 'Send successfully',
    msg6: 'Language',
    msg7: 'Zone',
    msg8: 'Please select area code',
    //手动提现
    manual: 'Manual Withdrawal',
    manual1: 'Fuzzy query',
    manual2: 'Please enter member / merchant account / order number',
    manual3: 'Manual withdrawal',
    manual4: 'Creation date',
    manual5: 'Merchants',
    manual6: 'Members',
    manual7: 'Please enter member name',
    manual8: 'Please select payment method',
    manual9: 'Payment details',
    manual10: 'cancellation of order',
    manual11: 'place order',
    manual12: 'Please select the reason for rejection',
    manual13: 'Failure review',
    manual14: 'Please input the withdrawal amount',
    manual15: 'Please confirm whether to submit the order?',

    //差额值设置
    differenceTitle: 'difference Set',
    differenceValue: 'difference Value',
    differenceTip: 'Please Difference Value',
    //提现提成查询
    percentage: 'Grade',
    percentage1: 'Total',
    percentage2: 'Total Commission in this period',
    percentage3: 'Number of commission transactions in this period',
    percentage4: 'Total accumulated Commission',
    percentage5: 'Accumulated commission amount',
    percentage6: 'Precise search',
    percentage7: 'or',
    percentage8: 'Withdrawal member',
    percentage9: 'Commission amount',
    percentage10: 'Commission time',
    percentage11: 'detailed information',
    percentage12: 'Commission details',
    //提现通道列表
    channel: 'Channel type',
    channel1: 'Channel status',
    channel2: 'Online status',
    channel3: 'Membership',
    channel4: 'Branch Company',
    channel5: 'Membership status',
    channel6: 'Member balance',
    channel7: 'Channel minimum',
    channel8: 'Private channel',
    channel9: 'Yes',
    channel10: 'No',
    channel11: 'Success times',
    channel12: 'Dead code times',
    channel13: 'Total number of channels',
    channel14: 'Total open',
    channel15: 'Total closed',
    //提现订单查询
    withdraw: 'Total cash withdrawal in this period',
    withdraw1: 'Number of withdrawals in this period',
    withdraw2: 'Total accumulated withdrawal',
    withdraw3: 'Accumulated withdrawal',
    withdraw4: 'Please enter account name or order number',
    withdraw5: 'query',
    withdraw6: 'Membership level',
    withdraw7: 'Operation time',
    withdraw8: 'Withdrawal details',
    withdraw9: 'Approval record of member withdrawal',
    withdraw10: 'Total amount of member\'s accumulated withdrawal',
    withdraw11: 'Total amount of members\'s current period',
    withdraw12: 'Enter account or order No. (including third party)',
    //会员提额审批
    limit: 'Amount of increase',
    limit1: 'Application times',
    limit2: 'Details of increase',
    limit3: 'Increase quota',
    limit4: 'time',
    limit5: 'Are you sure to raise the amount？',
    limit6: 'Are you sure you refuse to raise the amount？',
    //会员管理
    edituser: 'Account number:',
    edituser1: 'Name:',
    edituser2: 'All subordinates',
    edituser3: 'Company',
    edituser4: 'Exclusive services',
    edituser5: 'Exclusive merchants',
    edituser6: 'Direct subordinate',
    edituser7: 'Direct offline details',
    edituser8: 'Offline name',
    edituser9: 'people',
    edituser10: 'Withdrawal channel information',
    edituser11: 'QR code',
    edituser12: 'Can\'t operate',
    edituser13: 'Delete prompt',
    edituser14: 'Delete member',
    edituser15: 'And its subordinate members',
    edituser16: 'Deletion succeeded',
    edituser17: 'New exclusive services',
    edituser18: 'New exclusive members',
    edituser19: 'New exclusive branch',
    edituser20: 'Delete this account?',
    //个人中心
    myuser: 'essential information',
    myuser1: 'Modify data',
    myuser2: 'complete',
    myuser3: 'cancel',
    myuser4: 'Group company account number',
    myuser5: 'Name of group company',
    myuser6: 'Main currency',
    myuser7: 'Email',
    myuser8: 'Lower level information',
    myuser9: 'Subordinate type',
    myuser10: 'number',
    myuser11: 'Rate type',
    myuser12: 'Rate value',
    myuser13: 'Head office account number',
    myuser14: 'Name of head office',
    myuser15: 'Support currency / balance information',
    myuser16: 'Total account',
    myuser17: 'Support channel / rate information',
    myuser18: 'Quota details',
    myuser19: 'Merchant agent account number',
    myuser20: 'Merchant agent name',
    myuser21: 'Merchant flow purchase ratio',
    myuser22: 'Flow ratio',
    myuser23: 'Please enter a number or decimal',
    myuser24: 'Other currencies',
    myuser25: 'Other commissions',
    myuser26: 'My channel',
    myuser27: 'Rate information',
    myuser28: 'My passage',
    myuser29: 'Commission rate',
    myuser30: 'Other rates',
    myuser31: 'Rate value',
    myuser32: 'Employee Account',
    myuser33: 'Employee Name',
    myuser34: 'Modify mailbox',
    myuser35: 'Please enter a new mailbox again',
    myuser36: 'Mailbox is not set，Please contact the group company',
    myuser37: 'Please enter a new mailbox',
    myuser38: 'Mailbox input is inconsistent',
    myuser39: 'Modify phone',
    myuser40: 'Please improve the telephone information',

    //员工
    employee1: 'Number of employees',
    employee2: 'Please enter employee account number',
    employee3: 'Add employee',
    employee4: 'Employee account number',
    employee5: 'Employee name',
    employee6: 'Role type',
    employee7: 'Telephone number',
    employee8: 'edit',
    employee9: 'Login account',
    employee10: 'Edit employee profile',
    employee11: 'Email address format error',
    //银行
    bank: 'Number of banks',
    bank1: 'Add new bank',
    bank2: 'number',
    bank3: 'Name of bank\'s country',
    bank4: 'Detailed name',
    bank5: 'Type sort',
    bank6: 'Add bank type',
    bank7: 'Modify bank type',
    bank8: 'Please enter bank abbreviation',
    bank9: 'Please enter detailed name',
    bank10: 'Number of bank cards',
    bank11: 'Add new bank card',
    bank12: 'bank account',
    bank13: 'Daily limit',
    bank14: 'Weekly limit',
    bank15: 'Monthly limit',
    bank16: 'Bank type',
    bank17: 'Bank outlets',
    bank18: 'Confirm to delete the bank card?',
    bank19: 'Please confirm deletion?',
    bank20: 'Add bank card',
    bank21: 'Modify bank card',
    bank22: 'Please enter the account number',
    bank23: 'Country',
    bank24: 'English name of Bank',
    bank25: 'Open or not',
    bank26: 'Last modified by',
    bank27: 'none',
    bank28: 'Fail, please try again',
    bank29: 'Fail to get data, please select again',
    bank30: 'Please input the Bank branch information',
    bank31: 'Please enter the account name',
    bank32: 'Please input bank account number',
    bank33: 'Bank card payment',
    bank34: 'Flow control collection channel',
    bank35: 'Global financial collection channel',
    bank36: 'Advertising push flow collection channel',
    bank37: 'Local currency financial collection channel',
    bank38: 'Add collection channel',
    bank39: 'Edit colletion channel',
    bank40: 'New collection channel',
    bank41: 'Please select collection channel type',
    bank42: 'Transfer by scanning code',
    bank43: 'Digital money transfer',
    bank44: 'Taiping Stock Exchange',
    bank45: 'Chain name channel',
    bank46: 'Wallet address',
    bank47: 'Name of digital currency',
    bank48: 'Collection email',
    bank49: 'Scan type',
    bank50: 'Please enter the trading platform',
    bank51: 'Please enter the wallet address',
    bank52: 'Please select collection QR code',
    bank53: 'Please enter the collection email',
    bank54: 'Please enter the collection account number',
    bank55: 'Please input scan type',
    bank56: 'Please enter the correct wallet address, which must contain English letters, numbers and colon',
    bank57: 'Reset',
    bank58: 'Transfer quantity',
    bank59: 'Bank card type',
    bank60: 'Global finance',
    bank61: 'Local currency financing',
    bank62: 'Streaming advertising',
    bank63: 'Flow control',
    bank64: 'Bank address',
    bank65: 'Country of receiving bank',
    bank66: 'Receiving bank code',
    bank67: 'Receiver Address',
    bank68: 'Bank Country Branch Code',
    bank69: 'Please enter the address of the receiving bank',
    bank70: 'Please enter the country of the receiving bank',
    bank71: 'Please input the code of receiving bank',
    bank72: "Please enter the payee's address",
    bank73: 'The bank card status has been opened and cannot be modified',
    bank74: 'Merchant recharge collection channel',
    bank75: 'Incomplete transfer information',
    bank76: 'Merchant recharge',
    bank77: 'Code scanning collection account number',

    //角色
    role: 'Role',
    role1: 'Please enter the role name',
    role2: 'query',
    role3: 'add',
    role4: 'Role name',
    role5: 'jurisdiction',
    role6: 'add',
    role7: 'Role name cannot be empty',
    role8: 'The menu must be entered',
    role9: 'Delete role, continue?',
    role10: 'Role deleted successfully',
    role11: 'The selected role will be deleted. Do you want to continue?',
    //菜单
    menu: 'Menu',
    menu1: 'Please enter the menu name',
    menu2: 'title',
    menu3: 'route',
    menu4: 'Icon',
    menu5: 'order',
    menu6: 'Enable',
    menu7: 'Display when setting',
    menu8: 'Submenu',
    menu9: 'add',
    menu10: 'group',
    menu11: 'branch office',
    menu12: 'Merchant agent',
    menu13: 'Headquarters',
    menu14: 'Add submenu',
    menu15: 'Title cannot be empty',
    menu16: 'The path cannot be empty',
    menu17: 'Icon cannot be empty',
    menu18: 'Modify submenu',
    menu19: 'The selected menu will be deleted. Do you want to continue?',
    menu20: 'Menu deleted successfully',
    menu21: 'Name',
    menu22: 'h',
    menu23: 'Refresh',
    menu24: 'Kick it all out',
    menu25: 'm',
    menu26: 'Login Time',
    menu27: 'Online Time',
    menu28: 'Login IP/Home',
    menu29: 'Login Method/Source',
    menu30: 's',
    menu31: 'd',
    menu32: 'Kick Out',
    menu33: 'Is the user offline?',
    menu34: 'Operation successful',
    menu35: 'Are all users offline?',
    //兑换
    exchange: 'Whether to enable cash payment and exchange function？',
    exchange1: 'Enable',
    exchange2: 'Not enabled',
    exchange3: '(Subordinates will not be able to use them)',
    exchange4: 'No currency opened',
    exchange5: 'Intercontinental choice',
    exchange6: 'Selected countries',
    exchange7: 'Expand selection',
    exchange8: 'Province selection',
    exchange9: 'Municipal choice',
    exchange10: '（Click Select）',
    exchange11: 'List of countries',
    exchange12: 'List of provinces',
    exchange13: 'Batch open / single select subordinate',
    exchange14: 'Click Select',
    exchange15: 'Click reselect',
    exchange16: 'Whether to enable the chip payment exchange function？',
    exchange17: 'Club selection',
    exchange18: 'New club',
    exchange19: 'Name of Club',
    exchange20: 'Club status',
    exchange21: 'Please input club name',
    exchange22: 'Are you sure you want to delete the club?',
    exchange23: 'Delete confirmation',
    exchange24: 'Whether to enable the digital payment exchange function？',
    exchange25: 'Digital currency',
    exchange26: 'New platform',
    exchange27: 'Platform name',
    exchange28: 'Digital currency added',
    exchange29: 'Please enter the platform name',
    exchange30: 'Please select digital currency',
    exchange31: 'Are you sure you want to delete this platform?',
    exchange32: 'City list',
    exchange33: 'A dispatch order is formed when the equivalent value is less than ',
    exchange34: 'USD',
    exchange35: '平台代理会员',
    exchange36: '所选城市现有',
    exchange37: '位平台代理会员',
    exchange38: '所选城市不存在平台代理会员',
    //货币汇率
    currency1: 'Legal currency',
    currency2: 'Digital currency',
    currency3: 'Please enter currency name',
    currency4: 'Add currency',
    currency5: 'Currency code',
    currency6: 'Name of country',
    currency7: 'Relative exchange rate',
    currency8: 'Currency code',
    currency9: 'Main currency',
    currency10: 'After modifying this page, please save it before proceeding to the next page',
    currency11: 'New legal currency',
    currency12: 'Modify legal currency',
    currency13: 'Please enter currency code',
    currency14: 'Please enter the country name',
    currency15: 'Are you sure you want to delete the currency?',
    currency16: 'Please confirm deletion?',
    currency17: 'Add digital currency',
    currency18: 'Currency name',
    currency19: 'New digital currency',
    currency20: 'Modify digital currency',
    currency21: 'Currency code',
    currency22: 'Legal tender',

    loading: 'Loading...',
    WECHAT_PAY: 'Wechat',
    ALI_PAY: 'Alipay',
    CREDIT_PAY: 'Wechat Reward Code',
    PERSONAL_BANK_PAY: 'Personal bank',
    ENTERPRISE_BANK_PAY: 'Corporate bank',
    CLOUD_FLASH_PAY: 'UnionPay',
    MER_UNMATCH: 'Matching failed',
    BANK_PAY: 'Bank Transfer',
    SCAN_PAY: 'Cash withdrawal by scanning code',
    PAYPAL_PAY: 'PayPal',
    ZALO_PAY: 'Zalo Pay',
    UPI_PAY: 'Upi',


    MER_PENDING: 'Processing',
    MER_SUCCESS: 'Completed',
    MER_CANCEL: 'Cancellation order',
    MER_FAULT: 'trouble ticket',
    MER_FAULTDONE: 'Fault complete',
    MER_PROCESS: 'To be paid',
    MER_RETRIAL: 'Reviewed',
    ALL: 'ALL',
    SOLD: 'Sold',
    WAITING: 'Waiting',
    SUCCESS: 'Success',
    REJECTED: 'Rejected',
    BEARING: 'Bearing',
    FREEZE: "Freeze",
    vip: 'vip',
    vvip: 'vvip',
    l1: 'vip1',
    l2: 'vip2',
    l3: 'vip3',
    BRANCHROBING: 'Branch Order Grabbing',
    FAULT: 'trouble ticket',
    FAULTDONE: 'Fault complete',
    company: 'company',
    merchant: 'merchant',
    merchantAgent: 'Merchant agent',
    employee: 'employee',
    companyAgent: 'Headquarters',
    enable: 'enable',
    disable: 'disable',
    FREEZE_WAITING: 'Freeze pending approval',
    FREEZE_SUCCESS: 'Frozen successfully',
    FREEZE_REJECTED: 'Freeze reject',
    UNFREEZE_SUCCESS: 'Unfreezing succeeded',
    UNFREEZE_WAITING: 'Unfreezing pending approval',
    VIPROBING: 'Members are scrambling for orders',
    VIPPAYING: 'Member payment in progress',
    fddh: 'Currency exchange rate',
    wtdh: 'Entrusted exchange rate',
    hkdh: 'Remittance exchange rate',
    qqlc: 'Hedge money management',
    xylc: 'Luck Financing',
    lcze: 'Total amount of financial management',
    djje: 'Frozen amount',
    interest: 'Company dividend',
    register: 'register',
    globalBonus: 'Hedge money management',
    remittanceFault: 'Remittance failure',
    financial: 'Fortune management',
    payorderMER_PROCESS: 'Processing',
    bonus: 'Withdrawal Commission',
    payorderMER_FAULTDONE: 'Failure completion list',
    payorderMER_CANCEL: 'Cancellation order',
    payorderautoMER_CANCEL: 'Automatic cancellation of timeout',
    DEPOSITSUCCESS: 'Average score',
    legal: 'Currency Exchange',
    remittance: 'Remittance',
    luckBonus: 'Fortune management',
    entrust: 'Entrusted exchange',
    depositRemittance: 'Companies scramble for orders to recharge',
    payorderMER_RETRIAL: 'Retrial',
    payorderMER_SUCCESS: 'success',
    commission: 'commission',
    saleFinance: 'Selling financial management',
    WITHDRAWWAITING: 'Withdrawal',
    REMITTANCE: 'Remittance',
    entrustWAITING: 'Entrusted exchange',
    startPlaceholder: 'Start date',
    endPlaceholder: 'End date',
    ConditionalScreening: 'Conditional screening',
    FindDate: 'Find date',
    CurrencyType: 'Currency type',
    BaseCurrency: 'Base Currency',
    PleaseSelect: 'Please select',
    currency: 'currency',
    Rate: 'Rate',
    WithdrawalOrderNo: 'Withdrawal order No',
    WithdrawalBank: 'Withdrawal bank',
    WithdrawalScore: 'Withdrawal amount',
    WithdrawalAmount: 'Withdrawal percentage',
    Amount: 'Amount',
    ApplicationDate: 'Application date',
    Operation: 'Operation',
    Details: 'Details',
    WithdrawalCurrency: 'Withdrawal currency',
    BankAccount: 'Bank account',
    BankCardNumber: 'Bank card number',
    BankName: 'Bank name',
    NameOfPayBank: 'Name of pay bank',
    VerificationCode: 'Verification Code',
    Close: 'Close',
    Submit: 'Submit',
    Remarks: 'Remarks',
    ApplicationTime: 'ApplicationTime',
    Reviewer: 'Reviewer',
    AuditTime: 'AuditTime',
    CaptchaInformation: 'Verification code has been sent, please check',
    SubmitSuccess: 'Submitted successfully',
    addCompany: 'Add Branch Company',
    Information: 'Information',
    BranchAccount: 'Branch Account',
    LoginPassword: 'Login Password',
    BranchName: 'Branch Name',
    WithdrawalChannelControl: 'Withdrawal channel control',
    CurrencyTypes: 'Foreign currency switch settings',
    RoyaltyRate: 'Royalty Rate',
    ReviseSucceed: 'Revise Succeed',
    ReviseFail: 'Revise Fail',
    Revise: 'Revise',
    globalFinancial: 'Hedge money management',
    commonFinancial: 'General financial management',
    setAvatar: 'set avatar',
    avatarSetted: 'Avatar setted',
    avatarSettedError: 'Failed to set Avatar',
    chooseAgain: 'Please select again',
    freezeName: 'Applicants',
    selectImage: 'Select Image',
    avatarPreview: 'Head portrait preview',
    updateimage: 'Change picture',
    imageTips: 'Picture cannot be larger than',
    imageTypeTip: 'Image type must be',
    imageTypeTip2: 'One of',
    selectBank: 'Please select bank',
    deleteSucced: 'Successfully deleted',
    deleteFail: 'Deletion failed',
    matchCur: 'Matching currency',
    setUp: 'Set Up',
    drainagePersonName: 'Drainage Person',
    //电影
    movie: {
        selectMovieUp: 'Select movie to upload',
        updateMovie: 'Edit Movie',
        upTipTitle: 'warm reminder',
        upTip1: '1. Do not upload pornographic or illegal reactionary videos',
        upTip2: '2. Please use StarNet to upload videos, which means that you agree with us by default',
        movieAgreement: 'Content Agreement',
        movieOver: 'cover',
        updateOver: 'Modify cover',
        fileName: 'File name',
        recommendedArea: 'Recommended Area',
        movieDistrict: 'Movie District',
        fontCount: 'Word count: 5-100 words',
        upMovieSuccess: 'Video upload successfully! Transcoding.....',
        movieMsgTitle: 'You just uploaded video information',
        movieOverImg: 'Preview image',
        movieTitle: 'Title',
        movieTag: 'slogan',
        movieType: 'Category',
        movieAddress: 'Location',
        movieIntroduction: 'Introduction',
        movieUp: 'Continue uploading',
        againUp: 'Re-upload',
        release: 'release'
    },


    addMer: {
        nextStep: 'Next Step',
        back: 'Back',
        addtitle: 'Add merchant information',
        addBranchAgentTitle: 'New head office',
        addMerchantAgentTitle: 'Add merchant agent information',
        uptitle: 'Modify merchant information',
        shtitle: 'Review merchant information',
        titleDetail: 'Merchant details',
        agentAccount: 'Agent account',
        agentName: 'Agent name',
        dataSettings: 'Data settings',
        channelSettings: 'Channel settings',
        rateSettings: 'Rate setting',
        merchantType: 'Merchant type',
        merchantAccount: 'Merchant Account',
        currencyType: 'Currency Type',
        password: 'Login password',
        merchantName: 'Merchant name',
        phone: 'Phone number',
        accountLimit: 'Account limit',
        email: 'Email',
        domainName: 'domainName',
        role: 'Role',
        key: 'Key',
        platformInfo: 'PlatformInfo',
        largestSingleGold: 'The largest single entry',
        merchantKey: 'Merchant key',

        WechatCode: 'Wechat',
        AlipayCode: 'Alipay',
        wechatLikeCode: 'Wechat Reward Code',
        PersonalBankTransfer: 'Personal bank transfer',
        CorporateBankTransfer: 'Corporate bank transfer',

        wechatPayment: 'Wechat',
        alipayPayment: 'Alipay',
        bankpayment: 'Bank payment',
        cloudPayment: 'UnionPay',
        personalBank: 'Personal bank',
        corporateBank: 'Corporate banking',
        scanPayment: 'Scanning code',

        open: 'open',
        close: 'close',
        currencyTypes: 'Foreign currency switch settings',
        optionalCurrency: 'Optional currency',
        OptionalCurrencys: 'Optional currency',
        opened: 'opened',
        openedCurrency: 'Currency opened',
        depositServiceRate: 'Withdrawal commission rate',
        rujinServiceRate: 'Deposit service rate',
        dailiServiceRate: 'Agency rate',
        dailiOtherRate: 'Agency other rate',
        agencyRate: 'My commission rate',
        myRate: 'My rate',
        profitRate: 'My profit margin',
        otherRate: 'Other rates',
        statutoryExchange: 'Currency Exchange',
        entrustedExchange: 'Entrusted exchange',
        remittance: 'Remittance',
        remittanceExchange: 'Remittance',
        luckFinancing: 'Luck Financing',
        globalFinancing: 'Hedge money management',
        myHandRate: 'My handling rate',
        myOtherRate: 'My other rates',
        remittanceServe: 'Remittance service fee',

        luckFinancingRate: 'Luck Financing Rate',
        globalFinanceRate: 'Hedge money management Rate',
        LegalCurrencyExchange: 'Currency Exchange',
        EntrustedOrderExchange: 'Entrusted exchange',
        RemittanceServiceRate: 'Remittance service rate',
        legal: '法币兑法币',
        legalDigit: '法币兑数币',
        digit: '数币兑数币',
        digitLegal: '数币兑法币',

        cancel: 'Cancel',
        determine1: 'Determine',
        prevPage: 'Prev Page',
        nextPage: 'Next Page',
        adopt: 'Adopt',
        refuse: 'Refuse',
        merchant: 'Merchant',
        vvip: 'vvip',

        checkBranchAccount: 'Please enter the head office account number',
        checkBranchType: 'Please select branch type',
        checkBranchName: 'Please enter branch name',
        checkBranchComAgent: 'Please enter the name of head office',

        checkAccount: 'Please enter the merchant account number',
        checkPassword: 'Please input a password',
        checkName: 'Please enter the merchant name',
        checkphone: 'Please enter the contact number',
        checkAccountLimit: 'Please input the amount of account',
        checkEmail: 'Please enter email address',
        checkTrueEmail: 'Please enter the correct email address',
        checkUserType: 'Please select merchant type',
        checkCurrId: 'Please select currency type',
        checkRole: 'Please select role permission',

        EmailError: 'Email format error',
        LuckRateError: 'Please set the correct rate of return on lucky financial management',
        legalRateError: 'Please set the correct legal currency exchange rate',
        EntrustRateError: 'Please set the correct order exchange rate',
        RemittanceRateError: 'Please set the correct exchange rate for remittance procedures',

        whether: 'Whether',
        passageway: 'Passageway',
        passageways: 'Passageway information',
        Tips: 'Tips',
        determine: 'Determine',
        cancel1: 'Cancel',
        statusUpSuccess: 'Status update successful',
        statusUpFail: 'Status update failed',
        account: 'Account',
        openCurrencyCheck: 'Open current currency?',
        closeCurrencyCheck: 'Whether to close the current currency?',
        openSuccessfully: 'Open successfully',
        closeSuccessfully: 'Closed successfully',
        confirmationApproval: 'Confirmation of approval',
        rejectionApproval: 'Confirm rejection of approval',
        checkPass: 'Approval and confirmation',
        approved: 'Approved',
        rejected: 'Rejected',
        addSuccess: 'Add succeeded',
    },

    approvalList1: 'Merchants to be approved',
    approvalList2: 'Merchant Agent',
    approvalList3: 'Approved merchants',
    approvalList4: 'Conditional screening',
    approvalList5: 'customer type',
    approvalList6: 'ALL',
    approvalList7: 'vivp',
    approvalList8: 'Merchant',
    approvalList9: 'Branch Company',
    approvalList11: 'Please select',
    approvalList10: 'Currency type',
    approvalList12: 'enter one user name',
    approvalList13: 'User account',
    approvalList14: 'User name',
    approvalList15: 'customer type',
    approvalList16: 'Agent name',
    approvalList17: 'User currency',
    approvalList18: 'Other currencies',
    approvalList19: 'contact information',
    approvalList20: 'Approval time',
    approvalList21: 'Application time',
    approvalList22: 'Completion time',
    approvalList23: 'Approval status',
    approvalList24: 'Completed',
    approvalList25: 'Rejected',
    approvalList26: 'Pending approval',
    approvalList27: 'Review of Merchant Agent information',
    approvalList28: 'Information',
    approvalList29: 'Channel settings',
    approvalList30: 'Rate setting',
    approvalList31: 'Confirm closing',
    approvalUpCom1: 'Superior account number',
    approvalUpCom2: 'Branch account',
    approvalUpCom3: 'Account quota',
    approvalUpCom4: 'Currency type',
    approvalUpCom5: 'Branch name',
    approvalUpCom6: 'Phone number',
    approvalUpCom7: 'Email',
    approvalUpCom8: 'Domain name',
    approvalUpCom9: 'Login password',
    approvalUpCom10: 'Role',
    approvalUpCom11: 'Foreign currency switch settings',
    approvalUpCom12: 'Currency opened',
    approvalUpCom13: 'Optional currency',
    approvalUpCom14: 'opened',
    guanbi: 'close',
    kaiqi: 'open',
    approvalUpCom15: 'Reyalty rate',
    approvalUpCom16: 'Agency rate',
    approvalUpCom17: 'Wechat',
    approvalUpCom18: 'Alipay',
    approvalUpCom19: 'Wechat Reward Code',
    approvalUpCom20: 'Personal bank transfer',
    approvalUpCom21: 'Corporate bank transfer',
    approvalUpCom22: 'UnionPay',
    approvalUpCom23: 'Other rates',
    approvalUpCom24: 'Currency Exchange',
    approvalUpCom25: 'Entrusted exchange',
    approvalUpCom26: 'Remittance service rate',
    approvalUpCom27: 'Luck Financing Rate',
    tongguo: 'Adopt',
    jujue: 'Refuse',
    approvalUpCom28: 'Please select role permission',
    approvalUpCom29: 'Confirm approval？',
    approvalUpCom30: 'Confirmation of approval',
    queding: 'Determine',
    quxiao: 'Cancel',
    approvalUpCom31: 'Approved',
    approvalUpCom32: 'Approval failed',
    approvalUpCom33: 'Confirm rejection of approval？',
    approvalUpCom34: 'Approval rejection',
    approvalUpCom35: 'success',
    approvalUpCom36: 'Status update successful',
    approvalUpCom37: 'Closed successfully',
    approvalUpCom38: 'Open successfully',
    approvalUpCom39: 'Hedge money management Rate',
    approvalUpCom40: 'Modification of head office information',
    approvalUpCom41: 'Agent bonus rate',
    approvalUpCom42: 'Review merchant information',
    approvalUpCom43: 'View branch information',
    approvalUpCom44: 'Check merchant information',

    applyList1: 'Pending approval Merchants',
    applyList2: 'Approved Merchants',
    applyList3: 'Pending approval Merchant Agent',
    applyList4: 'Approved Merchant Agent',
    applyList5: 'Conditional screening',
    applyList6: 'Merchant type',
    applyList7: 'Please select',
    applyList8: 'ALL',
    applyList9: 'vvip',
    applyList34: 'merchant',
    applyList10: 'Currency type',
    applyList11: 'enter one user name',
    applyList12: 'Add new merchant',
    applyList13: 'Add new branch',
    applyList14: 'Merchant account number',
    applyList15: 'Merchant name',
    applyList16: 'Merchant type',
    applyList17: 'Branch account',
    applyList18: 'Branch name',
    applyList19: 'currency',
    applyList20: 'Other currencies',
    applyList21: 'contact information',
    applyList22: 'Creation time',
    applyList23: 'Approval status',
    applyList33: 'Operation',
    applyList24: 'Completed',
    applyList25: 'Processing',
    applyList26: 'Rejected',
    applyList27: 'Details',
    applyList28: 'Modification of head office information',
    applyList29: 'Information',
    applyList30: 'Channel settings',
    applyList31: 'Rate setting',
    applyList32: 'Confirm closing？',

    withdrawManage1: 'Merchant withdrawal application form',
    withdrawManage2: 'Total amount of accumulated withdrawal of merchants',
    withdrawManage3: 'Total withdrawal of merchants in the current period',
    withdrawManage4: 'Audit status',
    withdrawManage5: 'Bank of deposit',
    withdrawManage6: 'empty',
    withdrawManage7: 'Withdrawal percentage',
    withdrawManage8: 'Remarks',
    withdrawManage9: 'Phone / email',
    withdrawManage10: 'Login name',
    withdrawManage11: 'Withdrawal score',
    withdrawManage12: 'Balance before withdrawal',
    withdrawManage13: 'Accumulative withdrawal',
    withdrawManage14: 'Reasons for rejection',
    withdrawManage15: 'Withdrawal application form',
    withdrawManage16: 'Total amount of accumulated withdrawal',
    withdrawManage17: 'Total withdrawal in the current period',

    agentList1: 'All agents',
    agentList2: 'Maximum number of accesses',
    agentList3: 'Most connected merchants',
    agentList4: 'The total profit is the highest',
    agentList5: 'Please enter the agent name',
    agentList6: 'Total profit',
    agentList7: 'profit',
    agentList8: 'Access number',
    agentList9: 'Branch Management',
    OpenState: 'Open state',
    AgentType: 'Agent type',
    OtherCurrency: 'Other currencies',
    AccountBalance: 'Account balance',
    BalanceDetails: 'Balance details',
    CurrencyHeld: 'Currency held',
    Balance: 'balance',
    FinancialDetails: 'Financial details',
    State: 'state',
    SuperiorAccount: 'Name of superior',
    Unbound: 'Unbound',
    Complete: 'complete',
    ChannelCategory: 'channel Category',
    CommissionRate: 'commission Rate',

    settlement1: 'Agent withdrawal approval record',
    settlement2: 'the total amount of agent withdrawal',
    settlement3: 'The total amount of agent withdrawals on the day',
    settlement4: 'Mention modern account',
    settlement5: 'Approved',
    settlement6: 'Not approved',
    settlement7: 'Modify agent information',
    settlement8: 'Modify merchant agent information',
    PlsAccount: 'please enter your username',
    Export: 'Export',
    CurrentState: 'Current state',
    TransactionNO: 'Transaction number',
    WithdrawalAccount: 'Withdrawal account',
    WithdrawalName: 'Withdrawal name',
    UpperScore: 'Upper Score',
    Remainder: 'Remainder',
    CheckReject: 'Refuse to confirm',
    RejectReason: 'Please enter the reason for rejection',
    Input30Max: 'Enter up to 30 characters',
    RejectedSuccessfully: 'Refuse to succeed',
    ThroughSuccess: 'Passed successfully',
    ThroughConfirmation: 'Pass confirmation',
    title1: 'New branch',
    title2: 'Branch financial management approval record',
    title3: 'Branch lucky recharge record',
    title4: 'Total amount of financial management of branch',
    title5: 'Total amount of financial management on the day',


    company1: 'Number of branches',
    company2: 'The highest total financial management',
    company3: 'The highest total withdrawal',
    company4: 'Most offline',
    company5: 'Branch status',
    company6: 'All offline',
    company7: 'Bank card',
    company8: 'modify branch data',
    company9: 'bank card information',
    company10: 'account type',
    company11: 'account name',
    company12: 'name',
    company13: 'card number',
    company14: 'channel switch',
    company15: 'open channel?',
    company16: 'do you want to close the channel?',
    company17: 'transaction number',
    company18: 'account name',
    company19: 'branch account name',
    company20: 'recharge bank',
    company21: 'recharge amount',
    company22: 'exchange rate',
    company23: 'recharge score',
    company24: 'recharge current account balance',
    company25: 'branch recharge audit',
    company26: 'currency (exchange rate)',
    company27: 'name of receiving bank',
    company28: 'receiving bank card number',
    company29: 'receiving bank account',
    company30: 'account balance before recharge',
    company31: 'withdrawal application',
    company32: 'select currency',
    company33: 'please select currency',
    company34: 'deposit amount',
    company35: 'recharge score',
    company36: 'collection account',
    company37: 'recharge confirmation',
    company38: 'scoring successful',
    company39: 'operation successful, please wait for processing',
    company40: 'order no.',
    company41: 'order grabbing',
    company42: 'details of order grabbing情',
    company43: 'deposit bank',
    company44: 'transaction screenshot',
    company45: 'give up',
    company46: 'order timeout',
    company47: 'grabbing order successfully, please wait for processing',
    company48: 'Base curreny financing',
    company49: 'Foreign currency financing',
    company50: 'Reward',
    Company51: 'Commission rate of head office',
    Company52: 'Other rates of head office',
    company53: 'Order grabbing members',

    deposit1: 'total amount of deposit service charge in this period',
    deposit2: 'number of gold deposits in this period',
    deposit3: 'total amount of accumulated deposit handling charges',
    deposit4: 'accumulated gold amount',
    deposit5: 'please enter the user name or order number',
    deposit6: 'deposit amount',
    deposit7: 'handling charge amount',
    deposit8: 'collection time',
    deposit9: 'transaction status',
    deposit10: 'fault number',
    deposit11: 'processing amount',
    deposit12: 'fault sheet details',
    deposit13: 'collection amount',
    deposit14: 'screenshot',
    deposit15: 'actual amount',
    deposit16: 'please enter the actual amount',
    deposit17: 'processing completed',
    deposit18: 'retrial completed',
    deposit19: 'total amount of frozen funds',
    deposit20: 'number of frozen funds',
    deposit21: 'order number query',
    deposit22: 'new freeze',
    deposit23: 'applicant',
    deposit24: 'freezing applicant',
    deposit25: 'unfreeze applicant',
    deposit26: 'freeze reviewer',
    deposit27: 'unfreeze reviewer',
    deposit28: 'freezing time',
    deposit29: 'thawing time',
    deposit30: 'frozen state',
    deposit31: 'freezing passed',
    deposit32: 'freeze rejection',
    deposit33: 'apply for unfreezing',
    deposit34: 'unfreezing succeeded',
    deposit35: 'unfreeze reject',
    deposit36: 'new frozen funds',
    deposit37: 'apply',
    deposit38: 'freeze confirmation',
    deposit39: 'unfreezing confirmation',
    deposit40: 'successful application',
    deposit41: 'total amount of deposit in this period',
    deposit42: 'total amount of accumulated deposit',
    deposit43: 'deposit rate',
    deposit44: 'Deposit time',
    deposit45: 'activate',
    deposit46: 'reminder',
    deposit47: 'receiving currency',
    deposit48: 'collection method',
    deposit49: 'collection account number',
    deposit50: 'collection QR code',
    deposit51: 'failure reason',
    deposit52: 'receiving bank',
    deposit53: 'collection card number',
    deposit54: 'processing time',
    deposit55: 'activation succeeded',
    deposit57: 'reminder succeeded',
    deposit56: 'activation confirmation',
    deposit58: 'reminder confirmation',
    deposit59: 'deposit currency',
    deposit60: 'deposit account',
    deposit61: 'deposit share',
    deposit62: 'deposit qr code',
    deposit63: 'deposit bank',
    deposit64: 'deposit card number',


    deposit65: 'Total amount of recharge during this period',
    deposit66: 'Number of recharges during this period',
    deposit67: 'Cumulative total recharge',
    deposit68: 'Cumulative number of recharges',
    deposit69: 'Recharge method',
    deposit70: 'Recharge rate',
    deposit71: 'Recharge time',
    deposit72: 'Recharge share',
    deposit73: 'Account recharge',
    deposit74: 'Recharge QR code',
    deposit75: 'Recharge card number',
    deposit76: 'Total recharge fee for this period',
    deposit77: 'The total amount of accumulated recharge fees',
    deposit78: 'Interface log',


    exchane1: 'new exchange',
    exchane2: 'currency balance details',
    exchane3: 'withdrawal details',
    exchane4: 'exchange currency',
    exchane5: 'exchange currency',
    exchane6: 'withdrawal amount',
    exchane7: 'exchange information',
    exchane8: 'exchange rate',
    exchane9: 'exchange amount',
    exchane10: 'region selection',
    exchane11: 'choose intercontinental',
    exchane12: 'select country',
    exchane13: 'select province',
    exchane14: 'select city',
    exchane15: 'amount currency',
    exchane16: 'current selection',
    exchane17: 'region',
    exchane18: 'payee\'s contact information',
    exchane19: 'documents of payee',
    exchane20: 'password verification',
    exchane21: 'mobile phone number or email address',
    exchane22: 'click to get',
    exchane23: 'platform currency',
    exchane24: 'platform account',
    exchane25: 'total amount of exchange in this period',
    exchane26: 'total amount of exchange service charge in this period',
    exchane27: 'times of exchange in this period',
    exchane28: 'accumulated exchange amount',
    exchane29: 'total accumulated exchange handling charges',
    exchane30: 'cumulative exchange times',
    exchane31: 'cumulative exchange times',
    exchane32: 'Exchange order number',
    exchane33: 'exchange method',
    exchane34: 'exchange amount',
    exchane35: 'handling amount',
    exchane36: 'exchange time',
    exchane37: 'exchange date',
    exchane38: 'exchange currency',
    exchane39: 'exchange for digital currency',
    exchane40: 'exchange chips',
    exchane41: 'Payee select regional platform',
    exchane42: 'Payee selection area',
    exchane43: 'amount converted to digital currency',
    exchane44: 'Payee platform account number',
    exchane45: 'yourself',
    exchane46: 'reject?',
    exchane47: 'precision search',
    exchane48: 'or',
    exchane49: 'exchange order number',
    exchane50: 'exchange details',
    exchane51: 'wallet address',
    exchane52: 'protocol',
    exchane53: 'QR code',

    onLine: 'online',
    offLine: 'offline',
    VipManagement: 'member management',
    shanchu: 'Delete',
    UpdateVipDetail: 'modify member information',
    CashExchange: 'cash payment exchange',
    ChipExchange: 'chip Payment Exchange',
    NumberExchange: 'digital currency exchange',
    pls1: 'please enter the order number',
    pls2: 'please input the fault order number',
    pls3: 'please input the withdrawal order number',
    pls4: 'please input the fault reason',
    pls5: 'please select the exchange type',
    pls6: 'please select the currency to be exchanged',
    pls7: 'the exchange currency cannot be the same as the exchange currency',
    pls8: 'please select the currency to exchange',
    pls9: 'the converted currency cannot be the same as the exchanged currency',
    pls10: 'please select a region',
    pls11: 'please select a province',
    pls12: 'please select a city',
    pls13: 'the currency balance is insufficient, please re-enter',
    pls14: 'please select the club',
    pls15: 'please select platform',
    pls16: 'information error, please check',
    pls17: 'please input the order number and user account number',

    UserName: 'user name',
    loglout: 'sign out',
    PaymentMethod: 'payment method',
    OrderAmount: 'order amount',
    vipType: 'member type',
    Handle: 'process',
    Retrial: 'processing',
    vipAccount: 'member account',
    vipName: 'member name',
    Declare: 'declare',
    FaultReason: 'failure report reason',
    FaultImg: 'fault screenshot',
    FaultImgDetail: 'screenshot details',
    WithdrawalNo: 'withdrawal no.',
    WithdrawalType: 'withdrawal method',
    Handler: 'handler',
    Date: 'date',
    addFault: 'add a fault list',
    FaultOrder: 'fault order number',
    OrderStatus: 'order status',
    OldOrder: 'original order number',
    UserAccount: 'user',
    OrderNo: 'order number',
    CustomerType: 'user type',
    DepositMethod: 'deposit method',
    UserNickname: 'user nickname',
    companyNickName: 'Name of branch',
    ThematicCurrency: 'thematic currency',
    UsableCurrency: 'available foreign currency',
    Subsuperior: 'subordinate superior',
    TotalFinancial: 'total amount of financial management',
    TotalWithdrawal: 'total withdrawal',
    NewApply: 'new application',
    NewWithDraw: 'new withDrawl',
    ViewDetails: 'View Details',
    LoadingPaymentData: 'load payment data',
    Loaded: 'loaded successfully',
    checkAmount: 'please enter the correct amount',
    PayeeAccount: 'payee account number',
    PayeeName: 'payee name',
    MaxFiles5: 'select 5 files at most',
    MaxFiles1: 'Select 1 files at most',
    UploadSuccessful: 'upload succeeded',
    UploadFailed: 'upload failed, please check the network',

    product1: 'new product',
    product2: 'modify product',
    product3: 'product name',
    product4: 'product currency',
    product5: 'payback period',
    product6: 'purchasable members',
    product7: 'initial investment amount',
    product8: 'annualized calculation rate',
    product9: 'daily income',
    product10: 'three day revenue',
    product11: 'seven day revenue',
    product12: 'please select the return period',
    product13: 'please enter the product name',
    product14: 'total cumulative dividends',
    product15: 'total amount of current interest bearing financial management',
    product16: 'please enter the order number, product number or user account number',
    product17: 'product number',
    product18: 'Purchase quantity',
    product19: 'product cycle',
    product20: 'accumulated interest',
    product21: 'sell',
    product22: 'time',
    product23: 'interest',
    product24: 'sell confirmation',
    product25: 'sold successfully',
    product26: 'number of products',
    product27: 'most purchases',
    product28: 'please enter the product number or product name',
    product29: 'creator',
    product30: 'days',
    product31: 'purchase times',
    product32: 'financial products purchase audit records',
    product33: 'total amount of accumulated interest bearing financial management',
    product34: 'annualized rate',
    product35: 'New Hedge money management',
    product36: 'Modification time',
    product37: 'product type',
    product38: 'Merchant financial management',
    product39: 'Hedge money management',
    product40: 'new wealth management product ',
    product41: 'Merchant Financial Products',
    product42: 'Maximum purchase',
    companyFinancial: 'Head office Products',
    product43: 'branch can be used ',
    product44: 'Conversion amount',
    product45: 'Total amount',
    product46: 'Handling amount',
    product47: 'Group financial products',
    product48: '7 days',
    product49: '30 days',
    product50: '60 days',
    product51: '90 days',
    product52: 'Current',
    product53: 'cannot be deleted during interest calculation',

    merchant1: 'Merchant flow purchase approval record',
    merchant2: 'Total cumulative purchase flow of merchants',
    merchant3: 'Total purchase flow of merchants in this period',
    merchant4: 'Amount before purchase',
    merchant5: 'Purchase flow quota',
    merchant6: 'current account flow',
    merchant7: 'increase succeeded',
    merchant8: 'exclusive member',
    merchant9: 'please enter the exclusive member name to add',
    merchant10: 'increase',
    merchant11: '#',
    merchant12: 'view',
    merchant13: 'exclusive member details',
    merchant14: 'add time',
    merchant15: 'Number of services',
    merchant16: 'Total services',
    merchant17: 'exclusive channel switch',
    merchant18: 'do you want to delete',
    merchant19: 'add new exclusive members',
    merchant20: 'number of merchants',
    merchant21: 'highest amount of deposit',
    merchant22: 'the total amount of remittance exchange is the highest',
    merchant23: 'contact information',
    merchant24: 'Purchase times',
    merchant25: 'details of increase',
    merchant26: 'increase quota',
    merchant27: 'are you sure you want to raise the amount',
    merchant28: 'are you sure you want to refuse to raise the amount',
    merchant29: 'merchant flow approval record',
    merchant30: 'total cumulative flow amount of merchants',
    merchant31: 'total flow amount of merchants on that day',
    merchant32: 'Purchase amount of flow',
    merchant33: 'Traffic purchase ratio',
    merchant34: 'Purchase details',
    merchant35: 'Flow currency',
    merchant36: 'Exclusive branch',
    merchant37: 'Please enter the exclusive branch name to add',
    merchant38: 'Exclusive member channel',
    merchant39: 'Exclusive branch details',
    merchant40: 'Exclusive branch channel',
    merchant41: 'Please enter the exclusive branch name to add',
    merchant42: 'Whether to add new exclusive branches',
    merchant43: 'Are you sure you want to delete the branch',
    merchant44: 'Please input the amount of purchase flow',
    merchant45: 'Purchase payment currency',
    merchant46: 'Please input the amount of purchase flow',
    merchant47: 'The purchase flow limit should be more than 1000',
    merchant48: 'Expand settings',
    merchant49: 'Add all members?',
    merchant50: 'Flow balance',
    merchant51: 'MerchantAgent Belonging',
    merchant52: 'Headquarters Belonging',
    merchant53: 'Query parent',

    DelSuccess: 'deletion succeeded',
    remit1: 'total amount of remittance in this period',
    remit2: 'total amount of accumulated remittance',
    remit3: 'cumulative remittance times',
    remit4: 'remittance order number',
    remit5: 'remittance information',
    remit6: 'remittance amount',
    remit7: 'remittance Share',
    remit8: 'confirm collection',
    remit9: 'detailed remittance information',
    remit10: 'account number',
    remit11: 'Balance before remittance',
    remit12: 'Accumulated remittance',
    remit13: 'Receiving bank',
    remit14: 'Name of receiving account',
    remit15: 'Collection account No',
    remit16: 'withdrawal currency',
    remit17: 'currency balance',
    remit18: 'bank outlets',
    remit19: 'lower score',
    remit20: 'Remittance service rate',
    remit21: 'mobile email verification',
    remit22: 'please input your mobile phone number or email address',
    remit23: 'please enter the verification code',
    remit24: 'success',
    remit25: 'collection succeeded',
    remit26: 'retrieve',
    remit27: 'try again in seconds',
    remit28: 'the message was sent successfully. This message may be blocked. Please check it carefully',
    remit29: 'please enter the receiving bank',
    remit30: 'please input the collection account number',
    remit31: 'please input the collection card number',
    remit32: 'please enter the correct score',
    remit33: 'name of remitter',
    remit34: 'remitter\'s account number',
    remit35: 'New remittance',
    remit36: 'Remittance currency',
    remit37: 'Separate remittance',
    remit38: 'Actual remittance amount',
    remit39: 'Export points',

    OperationMode: 'operation mode',
    report1: 'total commission amount in this period',
    report2: 'total rate expenditure in this period',
    report3: 'number of operations in this period',
    report4: 'total accumulated Commission',
    report5: 'total cumulative rate expenditure',
    report6: 'cumulative number of operations',
    report7: 'exact search',
    report8: 'please enter the order number and name',
    report9: 'customer name',
    report10: 'merchant deposit',
    report11: 'withdrawal by members',
    report12: 'order time',
    report13: 'total transaction amount of agency customers',
    report14: 'total profit and loss of agent customer rate',
    report15: 'number of transactions of agency customers',
    report16: 'please enter the order number, account number and name',
    report17: 'customer account number',
    report18: 'member exchange',
    report19: 'member remittance',
    report20: 'members\' fortune management',
    report21: 'total dividends paid by branches',
    report22: 'transaction amount',
    report23: 'transaction rate',
    report24: 'Branch Company',
    report25: 'no data at present, please select the branch to view',
    report26: 'accumulated deposit',
    report27: 'recharge',
    report28: 'cumulative withdrawal',
    report29: 'grab the order and recharge',
    report30: 'withdrawal',
    report31: 'handling charge profit and loss',
    report32: 'account balance',
    report33: 'withdrawal and amount payable',
    report34: 'total amount of member contributions',
    report35: 'total withdrawal of members',

    report36: 'total amount of member remittance',
    report37: 'total amount of lucky financial management of members',
    report38: 'total amount of member exchange',
    report39: 'total profit and loss of member rate',
    report40: 'member account balance',
    report41: 'total amount of withdrawals by members',

    report42: 'total recharge amount of branches',
    report43: 'total amount of recharging by branches',
    report44: 'total profit and loss of branch rate',
    report45: 'branch account balance',
    report46: 'cash payable by branches',

    report47: 'group',
    report48: 'total amount of merchant deposit',
    report49: 'total profit and loss of members and branches',
    report50: 'Group company account balance',

    report51: 'company account quota',
    report52: 'total amount of financial management purchased by members',
    report53: 'total amount of accumulated withdrawal of members',
    report54: 'total amount of exchange entrusted by members',
    report55: 'total amount of member remittance',
    report56: 'total amount of member exchange remittance',

    report57: 'member withdraws Commission',
    report58: 'total service charge for exchange and remittance of members',
    report59: 'total profit and loss of member\'s cumulative rate',
    report60: 'financial balance',
    report61: 'account balance',
    report62: 'member financing and account balance',

    report63: 'normal recharge',
    report64: 'grab the order and recharge',
    report65: 'the company\'s accumulated recharge amount',
    report66: 'total Commission',
    report67: 'total dividend payment',
    report68: 'total accumulated profit and loss of the company',
    report69: 'operation type',
    report70: 'account quota change',
    report71: 'the company withdraws cash and Commission',
    report72: 'Member currency exchange',
    report73: 'member entrusted exchange',
    report74: 'company recharge',
    report75: 'collection',
    report76: 'cash in',
    report77: 'total',

    report78: 'total amount of merchant remittance',
    report79: 'total amount of withdrawal and entrusted exchange of merchants',
    report80: 'total profit and loss of merchant rate',
    report81: 'Branch / Merchant agent',
    report82: 'total amount of agent remittance',
    report83: 'total amount of agent withdrawal and entrusted exchange',
    report84: 'total profit and loss of agency rate',
    report85: 'total withdrawal and exchange amount of merchants, agents and members',
    report86: 'Total profit of group company',

    report87: 'currency',
    report88: 'total amount of deposit',
    report89: 'total amount of account withdrawal',
    report90: 'total amount of account remittance',
    report91: 'delegation method',
    report92: 'total amount of account entrusted exchange',
    report93: 'total handling charges',
    report94: 'total interest amount',
    report95: 'account rate total profit and loss',
    report96: 'financial dividend',
    report97: 'please enter the member account number',
    report98: 'buying financial management',
    report99: 'total amount of remittance',
    report100: 'Currency Exchange in / out',
    report101: 'total amount of entrusted exchange',
    report102: 'withdraw cash and Commission',
    report103: 'processing order amount',
    report104: 'outlier',
    report105: 'normal',
    report106: 'abnormal collection',
    report107: 'abnormal under collection',
    report108: 'Members withdraw profits',
    report109: 'Member remittance profit',
    report110: 'Member exchange profit',
    report111: 'Lucky financing Commission',
    report112: 'Hedge money management commission',
    report113: 'Live gift profit',
    report114: 'Total profit',

    Exchange: 'Exchange',
    manager: 'Management side modification',
    increaseLimit: 'Raise the amount',
    payorderMER_FAULT: 'Failure complete',
    payOrder: 'Commission',
    payorderthirdMER_CANCEL: 'Third party dispatch cancellation',

    cooperation1: 'Intended partner',
    cooperation2: 'Cooperative company',
    cooperation3: 'Read',
    cooperation4: 'Unread',
    cooperation5: 'Submission time',
    cooperation6: 'Details of interested partners',
    cooperation7: 'Name',
    cooperation8: 'Lastname',
    cooperation9: 'E-mail',
    cooperation10: 'Foreign trade service provider',
    cooperation11: 'Annual trading volume',
    cooperation12: 'Phone',
    cooperation13: 'Site URL',
    cooperation14: 'Corporate name',
    cooperation16: 'Position / Department',
    cooperation17: 'Less than $1 million',
    cooperation18: '$1 million - $5 million',
    cooperation19: '$5 million - $10 million',
    cooperation20: 'Over $10 million',
    cooperation21: 'Yes',
    cooperation22: 'No',
    cooperation23: 'Comments / complaints',
    cooperation24: 'contact information',

    el: {
        colorpicker: {
            confirm: 'OK',
            clear: 'Clear'
        },
        datepicker: {
            now: 'Now',
            today: 'Today',
            cancel: 'Cancel',
            clear: 'Clear',
            confirm: 'OK',
            selectDate: 'Select date',
            selectTime: 'Select time',
            startDate: 'Start Date',
            startTime: 'Start Time',
            endDate: 'End Date',
            endTime: 'End Time',
            prevYear: 'Previous Year',
            nextYear: 'Next Year',
            prevMonth: 'Previous Month',
            nextMonth: 'Next Month',
            year: '',
            month1: 'January',
            month2: 'February',
            month3: 'March',
            month4: 'April',
            month5: 'May',
            month6: 'June',
            month7: 'July',
            month8: 'August',
            month9: 'September',
            month10: 'October',
            month11: 'November',
            month12: 'December',
            week: 'week',
            weeks: {
                sun: 'Sun',
                mon: 'Mon',
                tue: 'Tue',
                wed: 'Wed',
                thu: 'Thu',
                fri: 'Fri',
                sat: 'Sat'
            },
            months: {
                jan: 'Jan',
                feb: 'Feb',
                mar: 'Mar',
                apr: 'Apr',
                may: 'May',
                jun: 'Jun',
                jul: 'Jul',
                aug: 'Aug',
                sep: 'Sep',
                oct: 'Oct',
                nov: 'Nov',
                dec: 'Dec'
            }
        },
        select: {
            loading: 'Loading',
            noMatch: 'No matching data',
            noData: 'No data',
            placeholder: 'Select'
        },
        cascader: {
            noMatch: 'No matching data',
            loading: 'Loading',
            placeholder: 'Select',
            noData: 'No data'
        },
        pagination: {
            goto: 'Go to',
            pagesize: '/page',
            total: 'Total {total}',
            pageClassifier: ''
        },
        messagebox: {
            title: 'Message',
            confirm: 'OK',
            cancel: 'Cancel',
            error: 'Illegal input'
        },
        upload: {
            deleteTip: 'press delete to remove',
            delete: 'Delete',
            preview: 'Preview',
            continue: 'Continue'
        },
        table: {
            emptyText: 'No Data',
            confirmFilter: 'Confirm',
            resetFilter: 'Reset',
            clearFilter: 'All',
            sumText: 'Sum'
        },
        tree: {
            emptyText: 'No Data'
        },
        transfer: {
            noMatch: 'No matching data',
            noData: 'No data',
            titles: ['List 1', 'List 2'], // to be translated
            filterPlaceholder: 'Enter keyword', // to be translated
            noCheckedFormat: '{total} items', // to be translated
            hasCheckedFormat: '{checked}/{total} checked' // to be translated
        },
        image: {
            error: 'FAILED'
        },
        pageHeader: {
            title: 'Back' // to be translated
        },
        popconfirm: {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }
    },
    addAnget: 'Add agent',
    addMerAnget: 'Add merchant agent',
    addComAnget: 'Add head office',

    im1: 'The query condition cannot be null',
    im2: 'Application is successful, please wait for approval',
    im3: 'Cannot send empty message',
    im4: 'Add Friend',
    im5: 'applied for',
    im6: 'loading failure',
    im7: 'Query',
    im8: 'account number',
    im9: 'Find a Friend',
    im10: 'Adopted',
    im11: 'Apply for a friend',
    im12: 'Loading failed',
    im13: 'No friends yet',
    im14: 'New Friends',
    im15: 'No chat log',
    im16: '[picture]',
    im17: '[Voice]',
    im18: 'No contact',
    im19: 'New friends',
    im20: 'Add New Friend',
    im21: 'Search history or account name',
    im22: 'Application flow limit error, please contact group company',
    im23: 'Search',
    im24: 'Build discussion group',
    im25: 'Send',
    im26: 'Please select the contact you want to add',
    im27: 'Groups',
    im28: 'Insufficient permissions',
    im29: 'No traffic purchase rate is set, please contact the group company',
    im30: 'Disband the group',
    im31: 'Do you want to disband the group?',
    im32: 'Successful dissolution',

    head1: 'Head office flow purchase approval record',
    head2: 'Total accumulated purchase flow of head office',
    head3: 'Total purchase flow of head office in this period',
    head4: 'All head office',
    head5: 'New head office',
    head6: 'Withdrawal approval record of head office',
    head7: 'Total accumulated withdrawal of head office',
    head8: 'Total withdrawal amount of the head office on the same day',
    head9: 'Account of withdrawal head office',
    head10: 'Name of applicant',
    head11: 'Flow purchase ratio of head office',
    head12: 'User information',
    head13: 'The minimum value of traffic purchase is 1,000',

    //员工part2
    em1: 'Last revision',
    em2: 'Reviser',
    em3: 'To examine',
    em4: 'Junior member',
    //银行卡
    em5: 'Quota',
    em6: 'Flow control bank card',
    em7: 'Flow control card',
    //流量控制
    em8: 'Traffic purchase rate',

    parentCompany: {
        firstTitle: "Head office back office management",
        vipError: 'There is abnormal member funds, please click to handle it immediately',
        subCompanyNumber: 'Number of Branches',
        headNumber: 'Number of head office',
        agentNumber: 'Number of agents',
        merchantNumber: 'Number of Merchants',
        vipNumber: 'Number of Members',
        messageTip: 'IM message prompt',
        noMessage: 'No message yet',
        entrustRequest: 'Exchange Request Review',
        hasNewRequest: 'You have a new user exchange, please approve',
        noNewRequest: 'No Exchange Request',
        merchantAccessDetail: 'Merchants Gold Flow',
        commission: 'Service Charge',
        bonus: 'royalties',
        systemRemit: 'System remittance',
        interestSum: 'Total Dividend',
        payOrderWithdraw: 'Notice of deposit withdrawal',
        hasNewAccessOrWithdraw: 'You have new user deposits/withdrawals, please approve',
        NoNewAccessOrWithdraw: 'No cash withdrawal request yet',
        merchantDetailSum: 'Total number of running pens',
        weChatNumber: 'WeChat Scavenger Streaming',
        aliPayNumber: 'Alipay Sample Streaming',
        bankNumber: 'Bank running water',
        cloudFlashNumber: 'Cloud flash dripping water',
        freeSumNumber: 'Number of handling pens',
        freeMerchantNumber: 'Business Input',
        freeRemitNumber: 'Remittance',
        freeEntrustNumber: 'exchange',
        bonusSumNumber: 'Number of withdrawal pens',
        bonusWithDrawNumber: 'Withdrawal Commission',
        bonusRemitNumber: 'Remittance Commission',
        bonusEntrustNumber: 'Exchange Commission',
        bonusLuckyNumber: 'Lucky Financing',
        systemRemitNumber: 'Number of transactions',
        remitNumber: 'Remittance',
        cashEntrustNumber: 'Cash Conversion',
        chipEntrustNumber: 'Chip Exchange',
        virtualCoinNumber: 'Virtual Currency Exchange',
        interestSumNumber: 'Coupon Frequency',
        parentCompanyInterest: 'Dividend distribution of group company',
        childCompanyInterest: 'Branch dividend',
        faultMessage: 'Failure List Notification',
        faultMessageTip: 'You have a new transaction/remittance failure slip, please process',
        noFault: 'No Fault List',
        merchantTodayDetail: 'Merchants are flowing gold this day',
        merchantSumDetail: 'Total Gold Input',
        companyTodayProfit: 'Company Today\'s Profit',
        sumProfit: 'Total Profit',
        freezeDate: 'Freeze data',
        sum: 'common',
        bit: 'number',
        freezeMoney: 'Frozen amount',
        merchantAccessRequest: 'Merchant withdrawal application',
        merchantAccessRequestTip: 'You have a new/advanced quota request for approval',
        noMerchantAccessRequest: 'No application for quota from merchants at this time',
        orderMessage: 'Order message',
        noOrder: 'No orders yet',
        orderMessageTip: 'A new order has been created with the order number',
        IMMessageTip: 'You have new news',
        popUpCurrName: 'Currency',
        popUpAmount: 'amount',
        withdrawal: 'Withdrawal',

        areaCode: 'Area Code'
    },
    subCompany: {
        vipError: 'There is abnormal member funds, please click to handle it immediately',
        firstTitle: 'Corporate Background Management',
        uid: 'Popularization Code',
        memberNumber: 'Number of Members',
        liuliang: 'Residual flow',
        balance: 'Account balance',
        imMessageTip: 'IM message prompt',
        noImMessage: 'No message yet',
        vipEntrustRemit: 'Member Exchange Remittance',
        vipEntrustRemitTip: 'Your member has new exchange/remittance, please check',
        noEntrustRemit: 'No Exchange Remittance Request',
        vipWithdrawDetail: 'Members withdraw running water',
        commission: 'Service Charge',
        bonus: 'royalties',
        vipRemitEntrust: 'Member Remittance Exchange',
        interestSum: 'Total Dividend',
        billAccessNotify: 'Grab Recharge Notification',
        billAccessTip: 'You have a new recharge order, please grab one',
        noBillAccess: 'No cash withdrawal request yet',
        withdrawSum: 'Total number of pens withdrawn',
        weChatCode: 'WeChat scanner',
        aliPayCode: 'Alipay Sample',
        weChatCodeZan: 'WeChat Appreciation Code',
        personalBank: 'Personal Bank',
        enterBank: 'Enterprise Bank',
        cloudFlashPay: 'Cloud flash payment',
        sumNumber: 'Total Pen Count',
        vipRemit: 'Member Remittances',
        vipLegalEntrust: 'Member currency exchange',
        vipCashEntrust: 'Member Cash Exchange',
        vipChipEntrust: 'Member Chip Exchange',
        vipVirtualCoin: 'Member Virtual Currency Exchange',
        balanceSumNumber: 'Total Pen Count',
        balanceWeChatCode: 'WeChat scanner',
        balanceAliPayCode: 'Alipay Sample',
        balanceWeChatCodeZan: 'WeChat Appreciation Code',
        balancePersonalBank: 'Personal Bank',
        balanceEnterBank: 'Enterprise Bank',
        balanceCloudFlash: 'Cloud flash payment',
        balanceLuckyMoney: 'Lucky Financing',
        remitSumNumber: 'Total Pen Count',
        remitVipRemit: 'Member Remittances',
        remitVipCashEntrust: 'Member Cash Exchange',
        remitVipChipEntrust: 'Member Chip Exchange',
        remitVipVirtualCoin: 'Member Virtual Currency Exchange',
        vipTodayWithdrawDetail: 'Members withdraw running water this day',
        sumOrderDetail: 'Total Gold Input',
        companyToadyProfit: 'Company Today\'s Profit',
        sumProfit: 'Total Profit',
        faultNotify: 'Failure List Notification',
        faultMessage: 'You have a new transaction/remittance failure slip, please process',
        noFault: 'No Fault List',
        vipLimitBalanceRequest: 'Membership Credit Request',
        vipLimitBalanceMessage: 'You have a new membership request for approval',
        noLimitBalance: 'No application for membership withdrawal at this time',
        payOrder: 'Order message',
        noOrder: 'No orders yet',
        orderMessageFormat: 'Member ({0}) presented a {2}{3} contribution through [{1}]',
        faultRemitMessageFormat: 'Member ({0}) has a remittance failure slip, please handle it',
        faultWithdrawMessageFormat: 'Member ({0}) has a remittance failure slip, please handle it',
        imMessageContent: 'You have new news',
        subcompany1: 'Branch flow purchase approval record',
        subcompany2: 'Total accumulated purchase flow of branches',
        subcompany3: 'Total purchase flow of branch in current period',
        subcompany4: 'Account flow',
        subcompany5: 'Select purchase currency',
        subcompany6: 'Please select purchase currency',
        subcompany7: 'Please load payment information',
        subcompany8: 'Remittance balance',
        subcompany9: 'Branch withdrawal approval record',
        subcompany10: 'Total accumulated withdrawal of branches',
        subcompany11: 'Total withdrawal amount of branches on that day',
        subcompany12: 'Withdrawal branch account',
        remitBalance: 'remit balance',
    },
    subCompanyAgent: {
        firstTitle: 'Branch Agent Background Management',
        agentCompanyNumber: 'Number of branches',
        balance: 'Account balance',
        imMessageTip: 'IM message prompt',
        noMessage: 'No message yet',
        vipWithdrawDetail: 'withdraw running water',
        commission: 'Service Charge',
        bonus: 'royalties',
        remitEntrust: 'Remittance Exchange',
        orderSumNumber: 'Total number of pens withdrawn',
        orderWeChatNumber: 'WeChat Sample',
        orderAliPayNumber: 'Alipay Sample',
        orderWeChatCodeNumber: 'WeChat Appreciation Code',
        orderPersonBankNumber: 'Personal Bank',
        orderEnterBankNumber: 'Enterprise Bank',
        orderCloudFlashNumber: 'Cloud flash payment',
        freeSumNumber: 'Total Pen Count',
        freeRemitNumber: 'Remittance',
        freeLegalNumber: 'Currency Exchange',
        freeCashNumber: 'Cash exchange',
        freeChipNumber: 'Member chips exchange',
        freeVirtualCoinNumber: 'Virtual currency exchange',
        bonusSumNumber: 'Total number of transactions',
        bonusVipOrder: 'Withdrawal by members',
        bonusVipRemit: 'Member remittance',
        bonusLegalEntrust: 'Currency Exchange',
        bonusEntrust: 'Entrusted exchange',
        bonusLuckyMoney: 'Fortune management',
        remitSumNumber: 'Total number of transactions',
        remitVipRemit: 'Remittance',
        remitCashRemit: 'Cash exchange',
        remitChipRemit: 'Chip exchange',
        remitVirtualCoinRemit: 'Virtual currency exchange',
        todayCompanyWithdrawDetail: 'Cash withdrawal flow of the company today',
        withdrawDetail: 'Total cash withdrawal',
        todayProfit: 'Today\'s profit',
        sumProfit: 'Total profit',
        payOrder: 'Withdrawal order',
        noBill: 'No order',
        orderMessageFormat: '{0} The company has a cash withdrawal order',
        imMessageContent: 'You have new information'
    },
    firstMerchant: {
        firstTitle: 'Merchant background management',
        limitBalance: 'Account limit',
        financialBalance: 'Total financial management',
        balance: 'Account Balance',
        vipOrderDetail: 'Water flowing into gold',
        commission: 'Service Charge',
        remitEntrust: 'Remittance Exchange',
        interestSum: 'Total interest accrued',
        vipOrderTotalNumber: 'Total number of pens withdrawn',
        vipOrderWeChatCode: 'WeChat scanner',
        vipOrderAliPayCode: 'Alipay Sample',
        vipOrderPersonBank: 'Personal Bank',
        cloudFlashNumber: 'Cloud flash payment',
        freeTotalNumber: 'Total Pen Count',
        freeAccessNumber: 'Financial Income',
        freeRemitNumber: 'Remittance',
        freeLegalNumber: 'Legal Exchange',
        freeEntrustNumber: 'Delegated Exchange',
        bonusTotalNumber: 'Total Pen Count',
        bonusWeChatCode: 'WeChat scanner',
        bonusAliPayCode: 'Alipay Sample',
        bonusWeChatZanCode: 'WeChat Appreciation Code',
        bonusPersonBankCode: 'Personal Bank',
        bonusEnterBankCode: 'Enterprise Bank',
        bonusCloudFlashCode: 'Cloud flash payment',
        bonusLuckyMoneyCode: 'Lucky Financing',
        remitTotalNumber: 'Total Pen Count',
        remitAccessNumber: 'Financial Income',
        remitRemitNumber: 'Remittance',
        remitLegalNumber: 'Currency Exchange',
        remitEntrustNumber: 'Delegated Exchange',
        todayOrder: 'Cash today',
        todayOrderSum: 'Total Gold Input',
        todayFree: 'Today\'s rate',
        todayFreeSum: 'Gross Spread',
        faultNotify: 'Failure List Notification',
        noFault: 'No Fault List',
        imMessageTitle: 'IM message prompt',
        noIMMessage: 'No message yet',
        orderMessage: 'Order message',
        noOrder: 'No orders yet',
        imMessageContent: 'You have new news',
        orderMessageFormat: 'You have a lump sum of {1}{2} purchased through [{0}]',
        remitFaultMessageFormat: 'You have a remittance failure slip, please handle it',
        orderFaultMessageFormat: 'You have a cash failure slip, please handle it',
    },
    firstMerchantAgent: {
        firstTitle: 'Business Agent Background Management',
        merchantNumber: 'Number of merchants',
        balanceNumber: 'Account Balance',
        imMessageTitle: 'IM message prompt',
        noIMMessage: 'No message yet',
        vipOrderAccessNumber: 'Water flowing into gold',
        commission: 'Service Charge',
        bonus: 'royalties',
        remitEntrust: 'Remittance Exchange',
        vipOrderTotal: 'Total number of pens withdrawn',
        vipOrderWeChatCode: 'WeChat scanner',
        vipOrderAliPayCode: 'Alipay Sample',
        vipPersonBankCode: 'Personal Bank',
        vipCloudFlashCode: 'Cloud flash payment',
        freeTotalNumber: 'Total Pen Count',
        freeRemit: 'Remittance',
        freeRemitEntrust: 'Currency Exchange',
        freeCashEntrust: 'Cash Conversion',
        freeChipEntrust: 'Chip Exchange',
        freeVirtualCoinEntrust: 'Virtual Currency Exchange',
        bonusTotalNumber: 'Total Pen Count',
        bonusPayOrder: 'Business Input',
        bonusRemitNumber: 'Merchant remittance',
        bonusRemitLegalNumber: 'Merchant currency Exchange',
        bonusEntrustNumber: 'Merchant Entrusted Exchange',
        bonusSumNumber: 'Total Pen Count',
        bonusRemitVipNumber: 'Remittance',
        bonusEntrustLegalNumber: 'Currency Exchange',
        bonusCashLegalNumber: 'Cash Conversion',
        bonusChipLegalNumber: 'Chip Exchange',
        bonusVirtualCoinNumber: 'Virtual Currency Exchange',
        todayMerchantAccessDetail: 'Today\'s merchants enter gold',
        sumAccessDetail: 'Total Gold Input',
        todayProfit: 'Today\'s Profit',
        sumProfit: 'Total Profit',
        orderMessage: 'Order message',
        noOrder: 'No orders yet',
        orderVVIPMessageFormat: "The {0} Senior Members generated an entry order",
        orderMerchantMessageFormat: "The {0} merchant produced a cash order",
        imMessageContent: 'You have new news',
        faultRemitMessageFormat: 'You have a remittance failure slip, please handle it',
        faultOrderMessageFormat: 'You have a cash failure slip, please handle it',
    },
    agentCustomerStatisticsReport: {
        customerName: 'Customer name',
        sumNumber: 'Number of strokes',
        money: 'amount of money'
    },

    chat1: 'New group chat',
    chat2: 'Done',
    chat3: 'Select group',
    chat4: 'Select group chat',
    chat5: 'Group chat information',
    chat6: 'Group chat name',
    chat7: 'Clear chat record',
    chat8: 'Delete and exit',
    chat9: 'Group name modification',
    chat10: 'Please enter group chat name',
    chat11: 'User account',
    chat12: 'Wechat Moments',
    chat13: 'Add to address book',
    chat14: 'Select members',
    chat15: 'No friends to add',
    chat16: 'Delete and exit?',
    chat17: 'Already',
    chat18: 'Move out of group chat',
    chat19: 'You already',
    chat20: 'invitation',
    chat21: 'Join group chat',
    chat22: 'You invited',
    chat23: 'Quit group chat',
    chat24: 'You have been removed from group chat',
    chat25: 'You',
    chat26: 'changed the group nickname to',
    chat27: 'chat',
    chat28: 'Mail list',
    chat29: 'Send a message',
    chat30: 'User Account',
    chat31: 'Enter group chat',
    chat32: 'Group name',
    chat33: 'You are friends now',
    chat34: 'Click add alias',
    chat35: 'Alias',
    chat36: 'Failed to set alias. Please reset',

    paypal1: 'PayPal account',
    paypal2: 'PayPal email',
    paypal3: 'PayPal QR code',
    paypal4: 'Please enter PayPal account number',
    paypal5: 'Please enter PayPal email',
    paypal6: 'Please select PayPal QR code',
    paypal7: 'PayPal payment',

    theChannel: {
        channel1: 'Channel type',
        channel2: 'Payment type',
        channel3: 'Channel Icon',
        channel4: 'New channel',
        channel5: 'Minimum Charge',
        channel6: 'Minimum Commission',
        channel7: 'Applicable groups',
        channel8: 'Maximum',
        channel9: 'Channel type(EN)',
        channel10: 'Channel type(zh-TW)',
        channel11: 'Channel type(Ja)',
        channel12: 'Channel type(Ko)',
        channel13: 'Icon size cannot exceed 2KB',
        channel14: 'Please complete the channel information',
        channel15: 'The minimum handling charge cannot be greater than the maximum rate',
        channel16: 'The minimum commission cannot be greater than the maximum rate',
        channel17: 'Modify channel information',
        channel18: 'Failed to modify channel status',
        channel19: 'Channel status modified successfully',
        channel20: 'Step value',
        channel21: 'The maximum rate cannot be less than 0',
        channel22: 'The minimum handling charge cannot be less than 0',
        channel23: 'The minimum commission cannot be less than 0',
        channel24: 'The step value cannot be less than 0',
        channel25: 'Please enter the channel type',
    },
    present: {
        presentName: 'Name of Present',
        presentImage: 'Pictures of Presents',
        presentCurrency: 'Present currency',
        presentCost: 'Price of the Present',
        enterPresentName: 'Please enter the name of present',
        newPresent: 'New Present',
        presentEn: 'Name of Present(EN)',
        presentTr: 'Name of Present(CHT)',
        presentJa: 'Name of Present(JPA)',
        presentKr: 'Name of Present(KOR)',
        editPresent: 'Modify gift information',
        completeInfo: 'Please fill in the gift information',
        limit: 'The image size cannot exceed ',
        AmoutErr: 'Gift price cannot be negative',
    },
    anchorCom: {
        anchorCompany: 'Live broadcasting company',
        number: 'Number of Companies',
        most: 'Most anchors recruited',
        highest: 'The highest live income',
        name: 'corporate name',
        anchors: 'Its anchor',
        living: 'living',
        giftAmount: 'Total gifts',
        new: 'New company',
        companyStatus: 'Company status',
        enterName: 'Please enter company name',
        account: 'Account number',
        companyName: 'Corporate name',
        edit: 'Modify live company data',
        returnsRate: 'Rate of return',
        flowRecord: 'Traffic purchase approval record',
        flowTotal: 'Total cumulative purchase traffic',
        flowCurTot: 'Total purchase traffic in this period',
        withdrawalRecord: 'Cash withdrawal approval record',
        withdrawalTotal: 'Total amount of cash withdrawn',
        withdrawalCurTot: 'Total cash withdrawal in current period',
        anchorsNum: 'Number of anchors',
        homeTitle: 'Background management',
        mustAccount: 'Live company account cannot be empty',
        mustName: 'Live company name cannot be empty',
        digital1: 'Company digital currency recharge record',
        digital2: 'Accumulated total recharge of the company',
        digital3: 'Total amount of company recharge on the day',
    },
    zhubo: {
        anchor: 'Anchors',
        numofLiving: 'Number of living',
        mostGifted: 'Most gifts receive',
        anchorStatu: 'Status',
        followers: 'Followers',
        new: 'New anchor',
        type: 'Anchor type',
        liveAnchor: 'Live Anchor',
        interactionAnchor: 'Interactive Anchor',
        account: 'Account',
        name: 'Name',
        plsSelectType: 'Please select anchor type',
        flowRecord: 'Anchor traffic purchase approval record',
        flowTotal: 'Total cumulative purchase traffic of Anchor',
        flowCurTot: 'Total purchase traffic in this period',
        enterName: 'Please enter the host name',
        edit: 'Modify anchor information',
        rate: 'Anchor\'s rate',
        plsEnterAct: 'Anchor account cannot be empty',
        plsEnterName: 'Anchor name cannot be empty',
        maximumRecharge: 'Maximum single recharge',
        rechargeCharge: 'Recharge charge',
        fansNum: 'Number of fans',
        toTop: 'Top',
        fanschange: 'Fans number modification',
        plsFans: 'Please input the number of fans',
        changeFans: 'Do you want to modify the number of fans of the anchor?',
        topAnchor: 'Is it the top anchor?',
        unTopAnchor: 'Do you want to cancel the anchor?',
    },
    giftRecord1: 'Total gift consumption',
    giftRecord2: 'Top consumer',
    giftRecord3: 'Types of gifts',
    giftRecord4: 'Number of gifts',
    giftRecord5: 'Anchor',
    giftRecord6: 'Please enter member name or order number',
    giftRecord7: 'Transaction type',
    giftRecord8: 'Anchor',
    giftRecord9: 'Gift expenses',

    anchorCompany: 'Live broadcasting company',
    sexAnchor: 'Interactive host',
    liveAnchor: 'Live anchor',

    merchantAgent1: 'Merchant agent flow purchase approval record',
    merchantAgent2: 'Total cumulative purchase traffic of merchant agents',
    merchantAgent3: 'Total purchase flow of merchant agent in current period',
    merchantAgent4: 'Merchant agent account number',
    merchantAgent5: 'Please enter merchant agent name',

    digital1: 'Digital currency recharge record',
    digital2: 'Cumulative total recharge',
    digital3: 'Total recharge on the day',
    digital4: 'Digital currency recharge',
    digital5: 'Recharge digital currency',
    digital6: 'Amount of digital currency',
    digital7: 'Recharge currency',
    digital8: 'Amount of digital currency',
    digital9: 'Choose digital currency',
    digital10: 'Chain name channel',
    digital11: 'Name of digital currency',
    digital12: 'trading platform',
    digital13: 'Wallet address',
    digital14: 'Transfer quantity',
    digital15: 'Collection QR code',
    digital16: 'Details of digital currency recharge',
    digital17: 'Please select digital currency',
    digital18: 'Please select recharge currency',
    digital19: 'Recharge success',
    digital20: 'Please enter the correct exchange rate',
    digital21: 'Digital currency recharge and collection channel',

    shortVideo1: 'Views',
    shortVideo2: 'Likes',
    shortVideo3: 'Comments',
    shortVideo4: 'Share',
    shortVideo5: 'Upload time',
    shortVideo6: 'View video',
    shortVideo7: 'Top',
    shortVideo8: 'Untop',
    shortVideo9: 'Edit video',
    shortVideo10: 'Online short videos',
    shortVideo11: 'Please complete the short video message',
    shortVideo12: 'Playback times must be greater than or equal to 0',
    shortVideo13: 'The number of likes must be greater than or equal to 0',
    shortVideo14: 'The number of comments must be greater than or equal to 0',
    shortVideo15: 'The number of shares must be greater than or equal to 0',
    shortVideo16: 'Video preview',
    shortVideo17: 'Click to view video',

    livingRoom1: 'Live rooms',
    livingRoom2: 'Room Number',
    livingRoom3: 'Viewers',
    livingRoom4: 'Present',
    livingRoom5: 'Please input user name / account number',
    livingRoom6: 'Please enter the room number',
    livingRoom7: 'Forced downcast',
    livingRoom8: 'Are you sure to force the room down?',
    livingRoom9: 'Edit the number of the viewers',
    livingRoom10: 'The number of viewers cannot be negative',
    livingRoom11: 'The number of viewers cannot be empty',
    ad: {
        addAd: 'Add an ad',
        adTitle: 'Ad Title',
        adUrl: 'Advertising image',
        jumpUrl: 'Jump link',
        adUrlTip: 'Please upload an ad image',
        adCountTip: 'The number of ads has been used up, please delete and create again',
        isdeleAd: 'Whether to delete this ad',
        updateAdTitle: 'modify ad',
    },
    notification: {
        addNotificationTitle: 'New announcement',
        updateNotificationTitle: 'Modification notice',
        notificationContent: 'Announcement content',
        notificationTitle: 'Announcement Title',
        tip: 'Please enter the announcement title/announcement content',
        isDelectNotification: 'Whether to delete this announcement'
    },
    userManage: {
        userManage1: 'Number of members',
        userManage2: 'Promoted the most',
        userManage3: 'Ordinary member',
        userManage4: 'Platform Trader',
        userManage5: 'OTC Trader',
        userManage6: 'Pending review',
        userManage7: 'reviewed',
        userManage8: 'Apply for upgrade',
        userManage9: 'Number of promotion',
        userManage10: 'Trader review',
        userManage11: 'Members fill in information',
        userManage12: 'System read information',
        userManage13: 'Real name',
        userManage14: 'Home Country',
        userManage15: 'Main transaction currency',
        userManage16: 'User main currency',
        userManage17: 'Home State/Province',
        userManage18: 'Home City',
        userManage19: 'Verification code mobile phone number',
        userManage20: 'System read country',
        userManage21: 'System read state/province',
        userManage22: 'System reads city',
        userManage23: 'Service fee',
        userManage24: 'Fixed account recharge',
        userManage25: 'Cash transaction recharge',
        userManage26: 'Fiat currency withdrawal',
        userManage27: 'Cash transaction fee',
        userManage28: 'Transfer and remittance fee',
        userManage29: 'Currency exchange fee',
        userManage30: 'Transfer and remittance service fee',
        userManage31: 'Channel balance',
        userManage32: 'Channel quota',
        userManage33: 'Idle',
        userManage34: 'Transaction',
    },
    order: {
        status: {
            ROBBING: '待接单',
            WAIT_REMIT: '等待转账',
            WAIT_PAY: '等待支付',
            WAIT_CONFIRM: '等待确认',
            PENDING: '等待审核',
            SUCCESS: '订单完成',
            REJECTED: '驳回',
            CANCEL: '已取消'
        }
    }
}
